import { useUpdateProfile } from '@/hooks';
import { useBearStore } from '@/store';
import { Button } from '@/ui';
import { XIcon } from 'lucide-react';
import { Link } from 'react-router-dom';

// update this component per new feature
const KEY = 'fpsr-v1';
const content = (
  <div className="flex flex-col gap-3">
    <p className="text-lg font-medium">Updated: render for me</p>
    <p className="text-steel-300">
      Don&apos;t want to bother with taking a screenshot?
    </p>
    <p className="text-steel-300">
      Powered by{' '}
      <Link to="https://fpsr.fprints.xyz" target="_blank">
        fpsr
      </Link>
      , you can let Fprints render a thumbnail for you. On expand, tagged posts
      re-render the blueprint live in your browser.
    </p>
    <p className="text-steel-300">
      Try it via Create → paste your string → Render for me.
    </p>
  </div>
);

export const NewFeature = () => {
  const profile = useBearStore(state => state.profile);
  const user = useBearStore(state => state.user);
  const removedNewFeature = useBearStore(state => state.removed_new_feature);
  const setRemovedNewFeature = useBearStore(
    state => state.setRemovedNewFeature
  );
  const setShowSignUpDialog = useBearStore(state => state.setShowSignUpDialog);
  const updateProfile = useUpdateProfile();

  if ((!profile && user) || (profile && profile.new_feature !== KEY))
    return null;

  if (removedNewFeature === KEY) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-60 flex w-full flex-col gap-5 bg-steel-950 px-6 pb-6 pt-5 text-steel-50 shadow-xl-top slide-in-from-left-1/2 md:bottom-4 md:left-auto md:right-4 md:w-[420px] md:rounded-2xl md:shadow-2xl">
      <div className="flex justify-end">
        <button
          className="touch-manipulation p-2 sm:p-0"
          onClick={() => setRemovedNewFeature(KEY)}
          data-umami-event="new-feature-dismiss-no-signup"
        >
          <XIcon className="size-5 sm:size-4" />
        </button>
      </div>
      <div className="flex flex-col gap-6">
        {content}
        {profile ? (
          <Button
            onClick={() => {
              updateProfile.mutate({ ...profile, new_feature: '' });
              setRemovedNewFeature(KEY);
            }}
            data-umami-event="new-feature-dismiss-signed-in"
          >
            Got it
          </Button>
        ) : (
          <Button
            data-umami-event="new-feature-dismiss-signing-up"
            onClick={() => {
              setRemovedNewFeature(KEY);
              setShowSignUpDialog(true);
            }}
          >
            Sign up to post yours!
          </Button>
        )}
      </div>
    </div>
  );
};
